import { Helper } from '../../Helper';
export class GetPropertyObjectKeysHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitHelper(node, options, sb.helpers.getPropertyObject);
            sb.emitOp(node, 'KEYS');
            sb.emitHelper(node, options, sb.helpers.arrFilter({
                map: () => {
                    sb.emitPushString(node, '__proto__');
                    sb.emitOp(node, 'EQUAL');
                    sb.emitOp(node, 'NOT');
                },
            }));
        }
    }
}

//# sourceMappingURL=GetPropertyObjectKeysHelper.js.map
